import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { SettingsService } from './settings.service';
import { NavigationService } from './nav.service';
import { PopupService } from '../core/popupmessage/popupmessage.service';

@Injectable()
export class MapsService{

    private mapsApiLoaded:boolean = false;
    private apiLoadedChecker:any
    private geocoder?: google.maps.Geocoder;

    constructor(private utilSrv:UtilityService, private settingSrv:SettingsService, private msgSrv:PopupService, private navSrv:NavigationService){

    }

    public isApiLoaded():boolean{
        return this.mapsApiLoaded;
    }


    public loadApiScript():Promise<void>{
        return new Promise((resolve,reject)=>{
            this.settingSrv.getSettings(["google_api_key"]).then((settings)=>{
                if(settings.length == 1){
                    if(!this.mapsApiLoaded){
                        let scriptUrl = "https://maps.googleapis.com/maps/api/js?key="+settings[0].settingValue+"&v=beta"
                        console.log("Script URL: ",scriptUrl)
                        this.utilSrv.loadScript(scriptUrl).then(()=>{
                            this.startApiLoadChecker().then(()=>{
                                this.loadLibraries().then(()=>{
                                    resolve();
                                }).catch((err)=>{
                                    console.error("Libraries Not Loaded",err)
                                    reject();
                                })
                            }).catch((err)=>{
                                console.error("ApiLoadChecker() Failed")
                                reject()
                            })
                        }).catch((err)=>{
                            console.error("API script Not Loaded", err)
                            reject();
                        })
                    }else{
                        resolve();
                    }
                }else{
                    console.log("Setting is empty",settings)
                    reject()
                }
                
            }).catch((err)=>{
                console.error(err);
                console.error(err);
                if(err.status === 401){
                    this.msgSrv.ok("Access Denied","Login required","",2,true).subscribe(()=>{
                        this.navSrv.navigateTo("login")
                    })
                }
                resolve(err)
            })

            
        })
    }

    public geocodeAddress(address:string): Promise<google.maps.LatLng> {
        if(typeof this.geocoder === "undefined"){
            this.geocoder = new google.maps.Geocoder();
        }
        return new Promise((resolve, reject)=>{
            let restrictions:google.maps.GeocoderComponentRestrictions = {country:'US'};
            let request:google.maps.GeocoderRequest = {region:"US", address:address,componentRestrictions:restrictions}
    
            if(address.length > 5){
                console.log(request);
                if(typeof this.geocoder !== "undefined"){
                    this.geocoder.geocode(request).then((result) => {
                        const { results } = result;
                        // if(typeof this.map !== "undefined"){
                        //     this.map.setCenter(results[0].geometry.location);
                        // }
                        console.log(JSON.stringify(result));
                        resolve(results[0].geometry.location)
                        // this.setMarker(results[0].geometry.location);
                        // this.getDeliverRates(results[0].geometry.location);
                        // this.map?.setZoom(14)
                        // marker.setPosition(results[0].geometry.location);
                        // marker.setMap(map);
                        // responseDiv.style.display = "block";
                        // response.innerText = JSON.stringify(result, null, 2);
                        return results;
                    }).catch((e) => {
                        alert("Geocode was not successful for the following reason: " + e);
                        reject()
                    });
                }else{
                    reject("Geocoder is null")
                }
            }else{
                reject("More Address Information Required")
                // this.msgSrv.ok("More Address Information Required","","",1);
            }
        })
      }

    private clearApiLoadChecker(){
        console.log("clearing Api Checker")
        clearInterval(this.apiLoadedChecker)
    }

    private startApiLoadChecker():Promise<void>{
        return new Promise((resolve, reject)=>{
            this.apiLoadedChecker = setInterval(()=>{
                console.log("Checking Api Loaded Status")
                if(this.isGoogleMapsLoaded()){
                    this.mapsApiLoaded = true;
                    resolve();
                    this.clearApiLoadChecker();
                }
            },500)
        })
        
    }

    private isGoogleMapsLoaded(): boolean {
        let loaded = typeof window.google !== 'undefined' && typeof window.google.maps !== 'undefined'
        console.log("is Google Maps Loaded?",loaded)
        return loaded
      }

    private async loadLibraries():Promise<void>{
        await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
        await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    }

}